function throwingStorage(error) {
  const message = String(error?.message || error || "Browser storage is unavailable");
  const fail = () => {
    throw new Error(message);
  };
  return Object.freeze({
    getItem: fail,
    setItem: fail,
    removeItem: fail,
  });
}

export function fishydexBrowserStorage(candidate, globalObject = globalThis) {
  if (candidate !== undefined) {
    return candidate;
  }
  try {
    return globalObject.localStorage;
  } catch (error) {
    return throwingStorage(error);
  }
}

export function verifyStoredValue(storage, key, expected) {
  const actual = storage.getItem(key);
  if (actual !== expected) {
    throw new Error(`Storage did not acknowledge ${key}`);
  }
}

export function removeAndVerify(storage, key) {
  storage.removeItem(key);
  if (storage.getItem(key) !== null) {
    throw new Error(`Storage did not remove ${key}`);
  }
}
